<script setup lang="ts">
import { useUserStore } from '@stores/user-store';
import { onMounted } from 'vue';
import { useRouter } from 'vue-router';

const userStore = useUserStore();
const router = useRouter();

onMounted(() => {
  if (userStore.isLoggedIn && userStore.userGroups) {
    if (userStore.userGroups[0] === 'portal-tc') {
      router.push({ name: 'townCouncilContractorsList' });
    }
  } else {
    router.push({ name: 'login' });
  }
});
</script>

<template>
  <div></div>
</template>
